import React from "react";
import { useJumboApp } from "@jumbo/hooks";
import { LAYOUT_NAMES } from "../../../layouts/layouts";

import SwitchProspeccion from "./SwitchProspeccion";
import { ContextProviderTransaccional } from "../context/TransaccionalContext";

import "../styles/main.css";

const ProspeccionCliente = () => {
  const { setActiveLayout } = useJumboApp();

  React.useEffect(() => {
    setActiveLayout(LAYOUT_NAMES.VERTICAL_DEFAULT);
  }, []);

  return (
    <>
      <ContextProviderTransaccional>
        <SwitchProspeccion />
      </ContextProviderTransaccional>
    </>
  );
};

export default ProspeccionCliente;
